module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.background !== null) ? _c('div', {
    staticClass: "page-background"
  }, [_c('img', {
    attrs: {
      "src": _vm.background
    }
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-667af1b3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/PageBackground.vue
// module id = 398
// module chunks = 1